module.exports = __webpack_public_path__ + "static/media/female-blue-v3.f61b3d82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/female-blue-v3.svg
// module id = 69
// module chunks = 0